import { FC, useState } from "react"
import { useInventoryContext } from "../../../hooks/use-inventory"
import { CategoryDialog } from "./category-dialog"
import { CategoryTagList } from "../../../components/molecules/category-tag-list"


export const Categories: FC = () => {
  const { categories, deleteCategoryWithCascade } = useInventoryContext()
  const [showCategoryForm, setShowCategoryForm] = useState(false)
  const [editItemId, setEditItemId] = useState("")

  const handleDeleteCategory = (categoryId: string) => {
    deleteCategoryWithCascade(categoryId)
  }

  const handleAddCategory = () => {
    setEditItemId("")
    setShowCategoryForm(true)
  }

  const handleEditCategory = (categoryId: string) => {
    setEditItemId(categoryId)
    setShowCategoryForm(true)
  }

  return (
    <>
      <CategoryTagList
        categories={categories}
        onDeleteCategory={handleDeleteCategory}
        onAddCategory={handleAddCategory}
        onEditCategory={handleEditCategory}
      />

      <CategoryDialog
        isShowing={showCategoryForm}
        close={() => {
          setShowCategoryForm(false)
          setEditItemId("")
        }}
        editItemId={editItemId}
      />
    </>)
}
